import { CACHE_BUSTING_TOKEN } from './cacheBusting';

//static files under /public are served under their own name, so webpack never hashes them and every
//caller has to agree on the same url for a change to reach the browser
export const LOGO_URL = `/assets/img/brand/logo.png?v=${CACHE_BUSTING_TOKEN}`;
